(ns frontend.view.modals.team-edit.events
  (:require
   [clojure.string :as string]
   [common.modules :as modules]
   [frontend.actions.entity :as entity-actions]
   [frontend.state.current-session :as session]
   [frontend.view.modals.components.processing-modal :as processing-modal]))

(defn modules-selected?
  [state]
  (let [{:keys [team/modules]} @state
        all-modules (modules/all-modules @session/tenant @session/tenant-plan)]
    (some (partial contains? modules) all-modules)))

(defn form-ready?
  [state]
  (let [team-name (:team/name @state)]
    (not (string/blank? team-name))))

(defn toggle-set
  [s val]
  (set (if (contains? s val)
         (disj s val)
         (conj s val))))

(defn modify-modules!
  [state kw val]
  (swap! state update kw toggle-set val))

(defn no-changes?
  [state*]
  (let [state @state*
        id (:db/id state)
        session-entity (session/get-entity id)]
    (->> [:db/id :team/modules :team/name :team/deny-export-access :team/read-only-team?]
         (remove (fn [attr]
                   (= (get session-entity attr)
                      (get state attr))))
         (empty?))))

(defn save!
  [state]
  (processing-modal/start-processing! state)
  (entity-actions/*->entity-update! (:db/id @state)
                                    (select-keys @state
                                                 [:team/modules
                                                  :team/name
                                                  :team/deny-export-access
                                                  :team/read-only-team?])
                                    (fn [_]
                                      (processing-modal/success! state))
                                    (fn [err]
                                      (processing-modal/error! state err))))
